export default __webpack_public_path__ + "static/media/tokenlist.749ce9c7.svg";